// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import Link from 'presentations/views/components/atoms/Link';
import {
  signUpPath,
  webPath,
  enterpriseInquiryPath,
} from 'presentations/routes/path';
import {
  spacing,
  fontSize,
  fontWeight,
  mediaMax,
  borderRadius,
} from 'presentations/views/styles';
import {
  primary,
  white,
  gray04,
  gray06,
  blueGrayPale,
} from 'presentations/views/styles/color';
import { addCampaignCode, CampaignCode } from 'presentations/routes/helper';
import { ProductType } from 'domains/models/blog_post/productType';
import * as tracker from 'presentations/views/helpers/analytics';
import { SyntheticEvent, useMemo } from 'react';
import { getLandingPageUrl } from '../OwnedContentBanner';

interface Props {
  productType: ProductType;
}
export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const router = useRouter();
  const code: CampaignCode = {
    medium: 'footer',
    source: 'jicoo',
    campaign: 'signup',
    content: 'resource',
  };
  const to = useMemo(() => {
    return getLandingPageUrl(props.productType);
  }, [props.productType]);
  const url = signUpPath({
    to: webPath(to),
    locale: router.locale,
  });
  const href = addCampaignCode(url, code);
  const title = t(`title_${props.productType}`);
  const description = t(`description_${props.productType}`);

  const onClickInquiry = (e: SyntheticEvent) => {
    tracker.setEvent('click corporative inquiry', {
      source: 'jicoo',
      product: 'resource',
      position: 'footer',
    });
  };

  return (
    <>
      <About>
        <Title>{title}</Title>
        <Sentence>{description}</Sentence>
        <LinkButton>
          <LinkButtonItem href={href} withoutNextLink>
            {t('Button')}
          </LinkButtonItem>
        </LinkButton>
        <EnterpriseInquiry
          href={enterpriseInquiryPath()}
          target="_blank"
          rel="noopener"
          onClick={onClickInquiry}
        >
          {t('Enterprise inquery')}
        </EnterpriseInquiry>
        {/* <PromotionContainer>
          <PricingPromotion />
        </PromotionContainer> */}
      </About>
    </>
  );
}

const About = styled.div`
  padding: ${spacing(32)};
  background: ${blueGrayPale};
  border-radius: ${borderRadius(16)};
  margin-bottom: ${spacing(32)};
  ${mediaMax.tablet} {
    font-size: ${fontSize(14)};
  }
`;
const Title = styled.h3`
  font-size: ${fontSize(20)};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing(24)};
`;
const Sentence = styled.div`
  margin-bottom: ${spacing(24)};
`;
const LinkButton = styled.div`
  display: flex;
  justify-content: center;
`;
const LinkButtonItem = styled(Link)`
  display: inline-block;
  border-radius: 50px;
  background: ${primary};
  color: ${white};
  font-weight: ${fontWeight('bold')};
  text-align: center;
  padding: ${spacing(16)} ${spacing(32)};
  cursor: pointer;
`;
const EnterpriseInquiry = styled(Link)`
  color: ${primary} !important;
  margin-top: ${spacing(12)};
  font-size: ${fontSize(12)};
  display: block;
  font-weight: ${fontWeight('bold')};
  text-align: center;
`;
